<template>
	<div class="col-lg-3">
		<div class="v-menu" :class="{'v-close': !OpenMenu}">
			<span class="v-title" @click="switchMenu">
				<i class="ion ion-md-menu"></i>
				All Categories
				<i class="fas fa-angle-down"></i>
			</span>
			<nav>
				<div class="v-wrapper">
					<ul class="v-list animated fadeIn">
						<li class="js-backdrop" v-for="category in getCategories" :key="category.id">
							<a @click="switchSubMenu(category.id)">
								<i class="fa fa-wifi"></i>
								<router-link
									:to="{
										name: 'ProductsByCategory',
										params: {id: category.id, slug: category.category_slug},
									}"
									>{{ category.name }}</router-link
								>
								<i v-if="category.child.length > 0" class="ion ion-ios-arrow-forward"></i>
							</a>
							<button class="v-button ion ion-md-add"></button>

							<div
								v-if="category.child.length > 0"
								class="v-drop-right"
								:style="
									openSubMenu.id == category.id && openSubMenu.status == true
										? 'display : block;'
										: ''
								"
								style="width: 700px"
							>
								<div class="row">
									<div class="col-lg-4" v-for="child in category.child" :key="child.id">
										<ul class="v-level-2">
											<li>
												<router-link
													:to="{
														name: 'ProductsByCategory',
														params: {id: child.id, slug: category.category_slug},
													}"
													>{{ child.name }}</router-link
												>
												<ul v-if="child.child.length > 0">
													<li v-for="child1 in child.child" :key="child1.id">
														<router-link
															:to="{
																name: 'ProductsByCategory',
																params: {id: child1.id, slug: category.category_slug},
															}"
															>{{ child1.name }}</router-link
														>
													</li>
												</ul>
												<ul v-else>
													<li><i class="fa fa-ban"></i></li>
												</ul>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</li>
						<!-- <li>
							<a class="v-more">
								<i class="ion ion-md-add"></i>
								<span>View More</span>
							</a>
						</li> -->
					</ul>
				</div>
			</nav>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import {mapGetters} from "vuex";
	export default {
		computed: {...mapGetters("cat", ["getCategories"])},
		data() {
			return {
				OpenMenu: false,
				openSubMenu: {
					//for switchig sub menu.
					status: false,
					id: "",
				},
				categories: [
					//this is just dummy.ignore this.
					{
						id: 1,
						name: "Beer",
						subcat: [
							{id: 1, name: "light Beer"},
							{id: 2, name: "Strong Beer"},
						],
					},
					{
						id: 2,
						name: "Beer 1",
						subcat: [
							{id: 1, name: "light Beer 1"},
							{id: 2, name: "Strong Beer 1"},
						],
					},
				],
			};
		},
		methods: {
			switchMenu() {
				(this.OpenMenu = !this.OpenMenu),
					(this.openSubMenu.status = false),
					(this.openSubMenu.id = "");
			},
			switchSubMenu(id) {
				if (window.innerWidth < 970) {
					if (id == this.openSubMenu.id) {
						this.openSubMenu.status = false;
						this.openSubMenu.id = "";
					} else {
						this.openSubMenu.id = id;
						this.openSubMenu.status = true;
					}
				}
			},
			MegaMenuItemClickHandler() {
				this.OpenMenu = false;
				const el = document.getElementsByClassName("products_by_category")[0];
				if (el) {
					this.$smoothScroll({
						scrollTo: el, // scrollTo is also allowed to be number
					});
				}
			},
		},
		mounted() {},
		watch: {
			$route(to, from) {
				this.OpenMenu = false;
			},
		},
	};
</script>

<style scoped>
	.js-backdrop a {
		text-transform: capitalize;
	}
	.v-level-2 a {
		text-transform: capitalize;
	}
</style>
